import { ContainerModule } from 'inversify';
import { QuizBankService2, QuizServiceSymbol } from './quiz-bank-service2'
import * as Commands from './commands'

export const quizServiceModule = new ContainerModule((bind) => {
  bind(QuizServiceSymbol).to(QuizBankService2).inSingletonScope();
  bind(Commands.LoadQuizzesCommandHandler).toSelf();
});
